import { Fragment } from 'react'
import Konva from 'konva'
import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import ShapeLabel, { LabelInteraction } from './ShapeLabel'

type Props = {
  shapes: VisualShape[]
  width: number
  height: number
  getNode?: (id: string) => Konva.Node | null
  interactionFor?: (shape: VisualShape) => LabelInteraction | undefined
}

const ShapeLabelsOverlay = ({
  shapes,
  width,
  height,
  getNode,
  interactionFor,
}: Props) => (
  <Fragment>
    {shapes.map((shape) =>
      shape.type !== 'text' && (shape.show_label ?? false) ? (
        <ShapeLabel
          key={`${shape.id}-label`}
          shape={shape}
          width={width}
          height={height}
          getNode={getNode ? () => getNode(shape.id) : undefined}
          interaction={interactionFor?.(shape)}
        />
      ) : null,
    )}
  </Fragment>
)

export default ShapeLabelsOverlay
